export const environment = {
  production: false,
  adalConfig: {
    tenant: "chevron.onmicrosoft.com",
    clientId: "101c57e4-58bf-4bb7-971b-7e39f3923443",
    postLogoutRedirectUri:
      "https://normsestimating-dev.azure.chevron.com/logout",
    endpoints: {
      "https://chevron.onmicrosoft.com/e915774d-b77c-4155-b0f3-dfd7a9413885":
        "https://chevron.onmicrosoft.com/e915774d-b77c-4155-b0f3-dfd7a9413885",
    },
  },
  msalConfig: {
    scopes: ["https://normse-test.azure.chevron.com/user_impersonation"],
    clientId: "e30163b7-047c-4751-ae78-81feb9d4c28a",
  },
  // app insights
  appInsights: {
    connectionString:
      "InstrumentationKey=2025b7e9-1bb6-4d56-a85c-2241b7f2a9e8;IngestionEndpoint=https://southcentralus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://southcentralus.livediagnostics.monitor.azure.com/;ApplicationId=2f72124e-4d1d-42ff-9f5a-0c193a7c1f06",
  },
  appCode: "webApp",
  apiEndpoint: "https://normsestimating-api-dev.azure.chevron.com/api",
  feedbackEndpoint: "https://templates-feedback-dev-cvx.azurewebsites.net/api",
  rateItEndpoint: "https://digitalpm-api-dev-cvx.azurewebsites.net",
  salesForceEndpoint:
    "https://chevronmfg--qa.sandbox.lightning.force.com/lightning/",
};
